module.exports = "<div class=\"live-info\">LIVE</div>\n<button class=\"live-button\">BACK TO LIVE</button>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/dvr_controls/public/index.html
 ** module id = 147
 ** module chunks = 0
 **/